import { type Environment } from 'react-relay';

import { fireLoginHandlers } from '../../utils/loginHandlers';
import { trackRegistrationComplete } from './authTracking';
import { setTokens, updateProfile } from './userStorageActions';

import { type AuthResponseType } from './authTypes';

export const authTrackingHandler = ({
    userRegistration,
    ga,
    environment,
    marketingOptIn,
    isGdprApplicable,
}: {
    userRegistration: AuthResponseType;
    ga: Record<string, string>;
    environment: Environment;
    marketingOptIn: boolean;
    isGdprApplicable: boolean;
}): void => {
    trackRegistrationComplete({ isGdprApplicable, marketingOptIn, ...userRegistration, ...ga });

    setTokens({
        ...userRegistration,
        environment,
    });

    updateProfile({ ...userRegistration, environment }).then(() => {
        fireLoginHandlers(userRegistration);
    });
};
